/* eslint-disable */
export default {
  download: 'Descargar',
  play: 'Reproducir',
  pause: 'Pausar',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
